<script setup lang="ts">
const { t } = useI18n({ useScope: 'local' })
</script>

<template>
  <VacancyDetailsContentCard color="muted-contrast" class="">
    <div class="mb-4">
      <Icon name="ph:heart-duotone" class="text-primary-500 mb-2 size-10" />
      <BaseHeading
        tag="h4"
        size="xl"
        weight="medium"
        class="mb-2"
      >
        {{ t('title') }}
      </BaseHeading>
      <BaseParagraph size="sm" class="text-muted-400">
        {{ t('p1') }}
      </BaseParagraph>
    </div>
  </VacancyDetailsContentCard>
</template>

<i18n lang="json">
{
  "en": {
    "title": "This is a 1:1 help request",
    "p1": "This is a 1:1 help request. This means you will be providing one-on-one help to someone in your area. A help request can be anything from helping with groceries, going for a walk, having a cup of coffee, or something completely different. You will agree together on what you will do."
  },
  "nl": {
    "title": "Dit is een 1:1 hulpvraag",
    "p1": "Dit is een 1:1 hulpvraag. Dit betekent dat je één-op-één hulp aan iemand biedt bij jou in de buurt. Een hulpvraag kan bestaan uit helpen met boodschappen doen, een wandeling maken, een kopje koffie drinken of iets heel anders. Je spreekt samen af wat jullie gaan doen."
  }
}
</i18n>
